<template>
<div>

<!-- Heading and Amount -->

<div style="display:flex;width:100%; max-width:600px;">
    <div style="flex-grow:1">
        <div>
            <span class="heading" style="font-size:18px">{{expense.name}}</span><span class="heading ml-2" v-if="!expense.optional">*</span>
            <div class="expense-subheading">{{expense.hint}}</div>
        </div>
        <div style="margin-top:-5px">
            <v-slider @end="sliderFinished" :max="expense.max" :min="0" :step="10" v-model="expense.value" thumb-label/>
        </div>
    </div>
    <div style="flex: 0 0 110px;text-align:right;" class="expense-amount">
        {{displayExpense}}
        <v-btn @click="showDetails" style="width:25px;height:25px" fab small dark color="grey lighten-1" icon>
            <v-icon>more_horiz</v-icon>
        </v-btn>
    </div>
</div>

<!-- Range Error Section -->

<div v-if="(!isInRange) && hasValue" style="max-width:500px">
    <div v-if="rangeError" class="pa-2 no-print grey--text text--darken-1">
        <v-icon color="red lighten-2" style="float:left;margin-right:10px">report_problem</v-icon>
        <span v-if="expense.name == 'Other'">Please give specifics</span>
        <span v-else >This is {{higherOrLower}} than expected, Your lender will require an explanation why.</span>
    </div>
    <v-textarea outline class="no-print mt-2" label="" single-line  :rows="2" v-model="expense.explanation" />
    <span class="print-only">Client comment: {{expense.explanation}}</span>
</div>

<!-- ************ Dialog Box ************** -->

<DialogBox :settings="breakdownDialog.settings" @save="saveBreakdown">
    <div class="pa-4">

        <div class="inset-text mb-3">
            <span style="background-color:yellow">Optional.</span> You can use the categories below to work out your {{expense.name}} expense in more detail.
        </div>

        <div v-for="item in expense.breakdown" class="pa-2" style="display:flex;width:100%;font-size:16px" :key="item.name">
            <div style="flex: 1 0 0">
                {{item.name}}
            </div>
            <div style="flex-basis:150px">
                $ <input v-model="item.value" type="text" class="expense-box show-border" />
            </div>
        </div>

        <div v-if="breakdownTotal" class="pa-2" style="display:flex;width:100%;font-size:16px">
            <div style="flex: 1 0 0">
                Total
            </div>
            <div style="flex-basis:150px">
                {{this.breakdownTotal | currency}}
            </div>
        </div>        
    </div>
</DialogBox>

</div>
</template>

<script>
import DataHelpers from '@/helpers/DataHelpers'
import NumberHelpers from '@/helpers/NumberHelpers'
import StringHelpers from '@/helpers/StringHelpers'
import Utilities from '@/helpers/Utilities'
import AlertHelpers from '@/helpers/AlertHelpers'
import DialogBox from '@/ui-elements/DialogBox'
import LivingExpenseHelpers from './LivingExpenseHelpers'


export default {
    data() {
        return {
            breakdownDialog: {
                settings: {
                    visible: false,
                    description: 'Breakdown',
                    title: "Breakdown",
                },
                breakdown: []
            },
        }
    },

    components: {
        DialogBox,
    },
    
    props: {
        expense: Object,
    },

    computed: {
        displayExpense() {
            if(this.expense.value == null)
                return ''
            else if(this.expense.value == 0)
                return 'Nil'
            else
                return StringHelpers.formatCurrency(this.expense.value)
        },
        // expected() {
        //     let expectedVal = this.expense.expectedValue
        //     let obj = {
        //         expectedMin: this.nearestTen(expectedVal * 0.8),
        //         expectedMax: this.nearestTen(expectedVal * 1.4) || 100,
        //     }

        //     if(this.expense.name ==  "Education") {
        //         obj.expectedMin = 0
        //     }
            
        //     return obj
        // },

        hasValue() {
            return (this.expense.value > 0)
        },

        isInRange() {
            return LivingExpenseHelpers.isInRange(this.expense)
        },
        overRange() {
            return LivingExpenseHelpers.isOverRange(this.expense)
        },
        underRange() {
            return LivingExpenseHelpers.isUnderRange(this.expense)
        },
        rangeError() {
            return !this.isInRange && this.expense.explanation.length < 3 && this.hasValue
        },
        endOfSlider() {
            return (this.sliderValue == this.expected.min && this.sliderValue > 0) || this.sliderValue == this.expected.max
        },

        higherOrLower() {
            if(this.overRange)
                return 'higher'
            if(this.underRange)
                return 'lower'
            return 'better'
        },

        breakdownTotal() {
            let total = 0
            this.expense.breakdown.forEach( item => {
                total += parseInt(item.value) || 0
            })
            return total
        }
  
    },

    methods: {
        saveBreakdown() {
            if(this.breakdownTotal) {
                if(this.breakdownTotal > this.expense.max)
                    this.expense.max = this.breakdownTotal
                this.expense.value = this.breakdownTotal
            }
        },

        showDetails() {
            this.breakdownDialog.settings.title = this.expense.name
            this.breakdownDialog.settings.visible = true
        },  

        nearestTen(num) {
            return parseInt(num / 10) * 10
        },

        sliderFinished() {
            // this.valueChanged()
            setTimeout( () => {
                if(this.expense.value == this.expense.max)
                    this.expense.max = this.nearestTen(this.expense.max * 1.5)
            }, 1000)
        },

        // valueChanged() {
        //     console.log('Running valuechanged')
        //     this.$set(this.expense, 'touched', true)
        //     this.$set(this.expense, 'valid', !this.rangeError)
        //     this.submitted = false
        // }
 
    },

    created() {

    },

    watch: {
        // 'expense.explanation': {
        //     handler: function(newVal) {
        //         this.valueChanged()
        //     },
        //     immediate: false,
        // },
        // 'expense.value': {
        //     handler: function(newVal) {
        //         this.valueChanged()
        //     },
        //     immediate: false,
        // }
    }
}
</script>

<style scoped>
    .expense-amount {
        font-size: 20px;
        color: #999;
    }
    .expense-subheading {
        font-size:12px;
        color: #999
    }

    .expense-box {
        border: solid 2px transparent;
        border-radius: 3px;
        padding-left:3px;
        width:55px;
    }

    .expense-box:focus, .expense-box:hover, .expense-box.show-border {
        border: solid 2px #777;
        outline: none;
        background-color: rgb(253, 255, 218);
    }
</style>




// WEBPACK FOOTER //
// LivingExpense.vue?d7e5efa4